<template>
  <div id="mains">
    <div class="mains-top">
      <div class="mains-top-inner">
        <h2>完善的运踪查询，及时准确</h2>
        <p>准确定位，及时查看</p>
      </div>
    </div>
    <div class="mains-input">
      <!-- <div class="mains-input-select">
        <el-select v-model="serchType" :placeholder="serchType"  @change="getValue">
          <el-option
            v-for="item in options"
            :label="item.label"
            :value="item.value"
            :key="item.value"
          >
          </el-option>
        </el-select>
      </div> -->
      <div class="mains-input-search">
        <el-input
          :placeholder="boxNum"
          v-model="serchText"
          @keyup.enter.native="geterData(); getAirData()"
          @focus="showHistory = true"         
          clearable
        >
          <template slot="prepend">集装箱号/单号</template>
        </el-input>

        <!-- 历史记录下拉面板 -->
        <div
          v-if="showHistory && historyList.length"
          class="history-panel"
        >
          <div class="history-header">
            <span>搜索历史</span>
            <el-button
              type="text"
              size="mini"
              @click="clearAllHistory"
            >
              清空
            </el-button>
          </div>
          <div
            class="history-item"
            v-for="(item, index) in historyList"
            :key="index"
            @click="selectHistory(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="mains-input-button">
        <el-button type="primary" icon="el-icon-search" @click="geterData(); getAirData(); saveHistory()">
        </el-button>
      </div>
    </div>

    <!-- tab切换  -->
    <div class="mains-tab">
      <el-tabs type="border-card">
        <el-tab-pane label="铁路信息">
          <!-- 基本信息 -->
          <div class="mains-info" v-if="gpsTypeValue==4">
            <table id="mains-table-railway">
              <thead>
                <tr>
                  <th>提单号</th>
                  <th>提货日期</th>
                  <th>进站日期</th>
                  <th>发车日期</th>
                  <th>到口岸日期</th>
                  <th>换装日期</th>
                  <th>出境日期</th>
                  <th>到站日期</th>
                  <th>到达目的地日期</th>
                  <th v-if="gloalData.chexiang_type==1">空箱返还日期</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ tiDanNo }}</td>
                  <td>{{ tiHuoDate }}</td>
                  <td>{{ jinZhanDate }}</td>
                  <td>{{ faCheDate }}</td>
                  <td>{{ kouAnDate }}</td>
                  <td>{{ huanZhuangDate }}</td>
                  <td>{{ chuJingDate }}</td>
                  <td>{{ daoZhanDate }}</td>
                  <td>{{ muDidiDate }}</td>
                  <td v-if="gloalData.chexiang_type==1">{{ huanXiangDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mains-info" v-if="gpsTypeValue!=4">
            <table id="mains-table-railway" v-show="!expireDate">
              <thead>
                <tr>
                  <th>集装箱号</th>
                  <th>当前位置</th>
                  <th >始发站</th>
                  <th >目的站</th>
                  <th >距离目的地(KM)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ cityData[0].boxnum }}</td>
                  <td>
                    <span>{{ cityData[0].nowcity }}</span>
                  </td>
                  <td >{{ cityData[0].origincity || '--' }}</td>
                  <td >{{ cityData[0].destcity || '--' }}</td>
                  <td >{{ endDist }}</td>
                </tr>
              </tbody>
            </table>
            <!-- 超过三年-->
            <table v-show="expireDate">
              <thead>
                <tr>
                  <th>集装箱号</th>
                  <th>当前位置</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ this.cityData[0].boxnum }}</td>
                  <td>
                    <span>{{ this.cityData[0].nowcity }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="el-main-body">
            <div class="el-data-hublist">
              <div class="el-lft-hubs">
                <div class="el-line-message">
                  <h3>最新信息</h3>
                </div>
                <ul class="infoTitle">
                  <li>时间</li>
                  <li>地址</li>
                </ul>
                <div class="el-sub-mess">
                  <div class="infoData" v-if="isData">
                    <img src="../../../static/images/mains/nodata.png" alt="" />
                    <p>暂无数据</p>
                  </div>
                  <table class="infoLists" v-if="!isData">
                    <tr
                      v-for="(item, index) in tableData[0].trackList"
                      :key="index"
                    >
                      <td>{{ item.time || '--' }}</td>
                      <td>{{ item.address || '--' }}</td>
                    </tr>
                    <template v-if="tableData.length === 2">
                      <tr
                        v-for="(items, index) in tableData[1].trackList"
                        :key="'second-'+index"
                      >
                        <td>{{ items.time || '--' }}</td>
                        <td>{{ items.address || '--' }}</td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </div>
            <!-- el-dest-list/ -->
            <!--      <div class="el-data-hublist">-->
            <!--        <div class="el-lft-hubs">-->
            <!--          <div class="el-line-message">-->
            <!--            <h3>最新信息</h3>-->
            <!--          </div>-->
            <!--          <div class="el-sub-mess">-->
            <!--            <ul class="el-lib-mess">-->
            <!--              <li-->
            <!--                v-for="(item, index) in tableData"-->
            <!--                :key="index"-->
            <!--                :class="{ on: isTrue == index }"-->
            <!--                @click="flexBoxs(index)"-->
            <!--              >-->
            <!--                &lt;!&ndash; <div class="el-cargo-tit" v-if="item.port">-->
            <!--                  <h4>-->
            <!--                    {{ index > 0 ? cargotit : cargotxt }}-->
            <!--                    {{ index > 0 ? (cargores = item.port.portCn) : "" }}-->
            <!--                  </h4>-->
            <!--                  <p>-->
            <!--                    {{ index > 0 ? (cargodate = item.trackList[0].time) : "" }}-->
            <!--                  </p>-->
            <!--                  <i :class="cargoico"></i>-->
            <!--                </div> &ndash;&gt;-->
            <!--                <div class="el-lib-cont">-->
            <!--                  <div class="el-lib-mark">-->
            <!--                    <el-table-->
            <!--                      empty-text="没有东西"-->
            <!--                      :data="item.trackList"-->
            <!--                      style="width: 100%"-->
            <!--                      :cell-style="cellStyle"-->
            <!--                      height="300"-->
            <!--                      border-->
            <!--                      :header-cell-style="{-->
            <!--                        'font-size': '16px',-->
            <!--                        color: '#555',-->
            <!--                        'background-color': '#eee',-->
            <!--                        'text-align': 'center',-->
            <!--                      }"-->
            <!--                    >-->
            <!--&lt;!&ndash;                      <el-table-column&ndash;&gt;-->
            <!--&lt;!&ndash;                        prop="id"&ndash;&gt;-->
            <!--&lt;!&ndash;                        label="序号"&ndash;&gt;-->
            <!--&lt;!&ndash;                        width="130"&ndash;&gt;-->
            <!--&lt;!&ndash;                      ></el-table-column>&ndash;&gt;-->
            <!--                      <el-table-column-->
            <!--                        prop="time"-->
            <!--                        label="上报时间"-->
            <!--                        width="260"-->
            <!--                      ></el-table-column>-->
            <!--                      <el-table-column-->
            <!--                        prop="address"-->
            <!--                        label="地址"-->
            <!--                      ></el-table-column>-->
            <!--                      <div slot="empty">-->
            <!--                        <el-empty description="暂无数据"></el-empty>-->
            <!--                      </div>-->
            <!--                    </el-table>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--              </li>-->
            <!--            </ul>-->
            <!--          </div>-->
            <!--        </div>-->
            <!--      </div>-->
            <div class="el-rit-hubs" style="margin-bottom: 40px;" v-if="gpsTypeValue != 4">
              <div class="el-map-message">
                <h3>轨迹图</h3>
                <!-- <ul class="el-tab-map">
                  <li :class="{ acon: acTrue }">腾讯地图</li>
                </ul> -->
              </div>
              <div class="el-map-cont BaiduMap" :style="baidusty">
                <iframe :src="`http://iot.link4future.com:8086/en/unLoginHistoryTrackWJ?devNo=${serchText}`" frameborder="0" width="100%" height="650"></iframe>
                <!-- <baidu-map
                  class="bm-view"
                  :center="center"
                  :zoom="zoom"
                  @ready="handler"
                  :scroll-wheel-zoom="true"
                >
                  <bm-polyline
                    :path="polylinePath"
                    stroke-color="red"
                    :stroke-opacity="0.8"
                    :stroke-weight="3"
                  ></bm-polyline>
                </baidu-map> -->
              </div>

              <div
                class="el-map-cont BingMap"
                style="
                  background-color: #fff;
                  z-index: 999;
                  position: absolute;
                  left: 0;
                  top: 75px;
                  color: #fff;
                  padding: 0;
                "
                :style="bingsty"
              >
                <div id="myMap" style="width: 100%; min-height: 500px"></div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        
      </el-tabs>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../global/footer";
//bingMap
export default {
  name: "Main",
  data() {
    return {
      gpsTypeValue: '',
      tiDanNo: '',
      caseNo: '',
      tiHuoDate: '',
      jinZhanDate: '',
      faCheDate: '',
      kouAnDate: '',
      huanZhuangDate: '',
      chuJingDate: '',
      daoZhanDate: '',
      muDidiDate: '',
      huanXiangDate: '',
      showHistory: false,
      historyList: [],
      //国内
      gnList: [],
      gwList: [],
      // 设备是否超过三年
      expireDate: false,
      isData: true,
      isAir: true,
      //Map
      center: { lng: 116.404, lat: 39.915 },  // 默认北京中心
      zoom: 5,
      //经纬度坐标集合
      polylinePath: [],
      //坐标点经纬度集合
      zbdPath: [],
      icons: ["11", "22", "33", "44"],
      infoWindow: {
        //窗体信息框
        show: true,
        contents: "测试文字",
      },
      //下拉搜索
      serchText: "",
      boxNum: "请输入要查询集装箱号/提单号",
      options: [
        {
          value: "1",
          label: "集装箱号/单号",
        },
        {
          value: "2",
          label: "空运单号",
        },
      ],
      serchType: "1",
      //关键节点
      cityName: "--",
      cityDist: "--",
      endName: "--",
      endDist: "--",
      //表格
      cityData: [
        {
          boxnum: "--",
          nowcity: "--",
          origincity: "--",
          destcity: "--",
          etd: "--",
          eta: "--",
        },
      ],
      //左侧信息
      cargotit: "已到达:",
      cargotxt: "最近的位置:",
      cargores: "--",
      cargodate: "--",
      cargoico: "el-icon-arrow-right",
      isTrue: 0,
      tableData: [{
        trackList: [{
          time: "--",
          address: "--",
          longtitude: 0,
          latitude: 0
        }]
      }],
      acTrue: true,
      acon: "acon",
      baidusty: {
        display: "block",
      },
      bingsty: {
        display: "none",
      },

      //bingMap
      bingMaplaTitude: null,
      bingMaploNgitude: null,
      bingMapData: [],

       // 空运
      airtransNo: "--", //单号
      origin: "--",
      destination: "--",
      latest_trace: "--",
      airtransno: "",
      latTime: "--",
      airflights: [{
          flight_no: "--",
          filght_date: "--",
          segment: "--",
          pieces: "--",
          weight: "--",
          volume: "--",
      }],
      airprocess: [],
      airhistory: [{
          track_process: "--",
          station_code: "--",
          pieces: "--",
          weight: "--",
          actual_time: "--",
          flight: "--",
      }],
      isShow: false
    };
  },
  mounted() {
    //接收箱号列表&&首页传递过来的箱号进行搜索
    if (this.$route.query.srce != "" && this.$route.query.srce != null) {
      this.serchText = this.$route.query.srce;
      this.geterData();
    } else if (this.$route.query.val != "" && this.$route.query.val != null) {
      this.serchText = this.$route.query.val;
      this.geterData()
      this.getAirData()
    }
  },
  methods: {
    saveHistory() {
      this.showHistory = false
      let val = this.serchText.trim();
      if (!val) return;

      // 去重：如果已存在则删除旧的
      this.historyList = this.historyList.filter((item) => item !== val);
      // 最新的放在最前面
      this.historyList.unshift(val);
      // 最多保存10条
      if (this.historyList.length > 10) {
        this.historyList = this.historyList.slice(0, 10);
      }
      // 存入本地
      localStorage.setItem("searchHistory", JSON.stringify(this.historyList));
      
    },

    // 从本地读取历史
    getHistoryFromLocal() {
      let history = localStorage.getItem("searchHistory");
      if (history) {
        this.historyList = JSON.parse(history);
      }
    },

    // 点击历史项回填
    selectHistory(item) {
      this.serchText = item;
      this.showHistory = false; // 选中后隐藏面板
      this.geterData()
      this.getAirData()
    },

    // 清空所有历史
    clearAllHistory() {
      this.historyList = [];
      localStorage.removeItem("searchHistory");
    },

    //baiduMap数据获取    //箱号搜索
    geterData() {
      //数据loading
      this.openLoading();
      //数据容器
      const gloalData = [];

      this.$axios
        .post("/Track/index", {
          serchType: this.serchType,
          serchText: this.serchText,
        })
        .then((res) => {
          let { gpsType } = res.data.data
          this.gpsTypeValue = gpsType
          
          this.closeLoading(this.openLoading());
          this.gloalData = res.data.data;
          this.bingMapData = this.gloalData;
          let dic = res.data.data
          this.tiDanNo = dic.master_no
          this.caseNo = dic.caseNumber ? dic.caseNumber : '--'
          this.tiHuoDate = (dic.tihuo_date && dic.tihuo_date.length > 0) ? dic.tihuo_date : '在途' 
          this.jinZhanDate = (dic.jinzhan_date && dic.jinzhan_date.length > 0) ? dic.jinzhan_date : '在途'
          this.faCheDate = (dic.fache_date && dic.fache_date.length > 0) ? dic.fache_date : '在途'
          this.kouAnDate = (dic.kouan_date && dic.kouan_date.length > 0) ? dic.kouan_date : '在途'
          this.huanZhuangDate = (dic.huanzhuang_date && dic.huanzhuang_date.length > 0) ? dic.huanzhuang_date : '在途'
          this.chuJingDate = (dic.chujing_date && dic.chujing_date.length > 0) ? dic.chujing_date : '在途'
          this.daoZhanDate = (dic.daozhan_date && dic.daozhan_date.length > 0) ? dic.daozhan_date : '在途'
          this.muDidiDate = (dic.mudidi_date && dic.mudidi_date.length > 0) ? dic.mudidi_date : '在途'
          this.huanXiangDate = (dic.huanxiang_date && dic.huanxiang_date.length > 0) ? dic.huanxiang_date : '在途'

          //内层数据集合
          let lstOne = this.gloalData.track || [];
          // console.log('Track data:', lstOne);
          
          //内层ports长度
          let porLen = this.gloalData.ports ? this.gloalData.ports.length : 0;
          //内层数据长度
          let tckLen = lstOne.length;
          //地图经纬度坐标
          //经度集合
          let lngArr = [];
          //纬度集合
          let latArr = [];
          //坐标点经度集合
          let zbdLng = [];
          //坐标点纬度集合
          let zbdLat = [];
          // console.log(this.gloalData);
          if (res.data.code === 1) {
            this.isData = false;
            this.expireDate = false;
            this.isAir = true;

            // 处理基础数据
            this.gloalData = res.data.data;
            
            // 设置表格数据
            if (this.gloalData && this.gloalData.track && this.gloalData.track.length > 0) {
              this.tableData = this.gloalData.track;
            } else {
              this.tableData = [{
                trackList: [{
                  time: "--",
                  address: "--"
                }]
              }];
              this.isData = true;
            }
            
            // 处理轨迹点数据
            const trackPoints = [];
            if (this.gloalData && this.gloalData.track && this.gloalData.track.length > 0) {
              const trackList = this.gloalData.track[0].trackList || [];
              trackList.forEach(point => {
                const lng = parseFloat(point.longtitude);
                const lat = parseFloat(point.latitude);
                if (!isNaN(lng) && !isNaN(lat)) {
                  trackPoints.push({ lng, lat });
                }
              });
            }

            // 设置轨迹点
            this.polylinePath = trackPoints;
            
            // 如果有点，设置地图中心
            if (trackPoints.length > 0) {
              this.center = trackPoints[0];
              this.zoom = 5;
            }

            // console.log('轨迹点：', this.polylinePath);
            // console.log('表格数据：', this.tableData);

            //关键节点 //目的站
            //关键节点
            this.cityName = this.gloalData.nextStation;
            //关键节点距离
            this.cityDist = this.gloalData.nextDistance;
            //目的地
            this.endName = this.gloalData.destination;
            //目的地距离
            this.endDist = this.gloalData.destDistance? Number(this.gloalData.destDistance).toFixed(0) : '--'
            //当前位置表格
            //箱号
            this.cityData[0].boxnum = this.gloalData.caseNumber || '--';
            //当前城市
            this.cityData[0].nowcity = this.gloalData.location || '--';
            //始发站
            this.cityData[0].origincity = (this.gloalData.ports && this.gloalData.ports.length > 0) ? this.gloalData.ports[0].portCn : '--';
            //目的站
            this.cityData[0].destcity = (this.gloalData.ports && this.gloalData.ports.length > 0) ? this.gloalData.ports[this.gloalData.ports.length - 1].portCn : '--';
            //ETD
            this.cityData[0].etd = this.gloalData.ETD || '--';
            //ETA
            this.cityData[0].eta = this.gloalData.ETA || '--';
            
            // 添加id
            this.tableData.forEach((items) => {
              if (items.trackList && Array.isArray(items.trackList)) {
                items.trackList.forEach((int, indent) => {
                  int.id = indent + 1;
                });
              }
            });
            // console.log(this.tableData[0].trackList)
            // console.log(this.tableData[1].trackList)
            // console.log(this.tableData.length)
            this.tableData.forEach((items, index, arr) => {
              items.trackList.forEach((int, indent, aro) => {
                int.id = indent + 1;
              });
            });
            // console.log(this.tableData);
            //关键节点城市经纬度
            let points = [];
            if (this.tableData.value && 
                this.tableData.value[0] && 
                this.tableData.value[0].trackList) {
              this.tableData.value[0].trackList.forEach(point => {
                const lng = parseFloat(point.longtitude);
                const lat = parseFloat(point.latitude);
                if (!isNaN(lng) && !isNaN(lat)) {
                  points.push({ lng, lat });
                }
              });
            }

            // 设置轨迹点
            this.polylinePath = points;
            
            // 如果有点，设置地图中心
            if (points.length > 0) {
              this.center = points[0];
              this.zoom = 5;
            }

            // console.log('轨迹点：', this.polylinePath);

            // 合成坐标点数组
            this.zbdPath = zbdLng.map((ints, indet) => {
              return {
                lng: ints,
                lat: zbdLat[indet],
              };
            });
          } else if (res.data.code === 2) {
            this.isData = false;
            this.expireDate = true;
            this.isAir = true;
            this.cityData[0].nowcity = this.gloalData.location;
            this.cityData[0].boxnum = this.gloalData.caseNumber;

            this.tableData = lstOne;
            this.tableData.forEach((items, index, arr) => {
              items.trackList.forEach((int, indent, aro) => {
                int.id = indent + 1;
              });
            });

            lstOne.forEach((item, index, arr) => {
              item.trackList.forEach((ins) => {
                //经度
                let gjLng = ins.longtitude;
                //维度
                let gjLat = ins.latitude;
                //添加关键节点城市经纬度
                lngArr.push(gjLng);
                latArr.push(gjLat);
              });
              //坐标点经纬度
              zbdLng.push(item.longtitude);
              zbdLat.push(item.latitude);
            });
            //首发城市经纬度
            let startLngarr = lstOne[lstOne.length - 1];
            //首发城市经度
            let startLng =
              startLngarr.trackList[startLngarr.trackList.length - 1]
                .longtitude;
            //首发城市纬度
            let startLat =
              startLngarr.trackList[startLngarr.trackList.length - 1].latitude;
            //添加首发城市经纬度
            lngArr.push(startLng);
            latArr.push(startLat);
            //坐标点添加首发城市经纬度
            zbdLng.push(startLng);
            zbdLat.push(startLat);
            //合成对象数组并赋值给数据集合
            this.polylinePath = lngArr.map((item, index) => {
              return {
                lng: item,
                lat: latArr[index],
              };
            });
            //合成坐标点对象数组并赋值给数据集合
            this.zbdPath = zbdLng.map((ints, indet) => {
              return {
                lng: ints,
                lat: zbdLat[indet],
              };
            });
          } else if (res.data.code === 3) {
            this.isData = false;
            this.expireDate = false;
            this.isAir = false;
            //关键节点 //目的站
            //关键节点
            this.cityName = this.gloalData.nextStation;
            //关键节点距离
            this.cityDist = this.gloalData.nextDistance;
            //目的地
            this.endName = this.gloalData.destination;
            //目的地距离
            this.endDist = this.gloalData.destDistance || '--'
            //当前位置表格
            //箱号
            this.cityData[0].boxnum = this.gloalData.caseNumber;
            //当前城市
            this.cityData[0].nowcity = this.gloalData.location;
            //始发站
            this.cityData[0].origincity = this.gloalData.ports[0].portCn;
            //目的站
            this.cityData[0].destcity = this.gloalData.ports[porLen - 1].portCn;
            //ETD
            this.cityData[0].etd = this.gloalData.ETD;
            //ETA
            this.cityData[0].eta = this.gloalData.ETA;
            //左侧列表数据             //定义数组id = indent + 1
            this.tableData = lstOne;
            // console.log(this.tableData[0].trackList)
            // console.log(this.tableData[1].trackList)
            // console.log(this.tableData.length)
            this.tableData.forEach((items, index, arr) => {
              items.trackList.forEach((int, indent, aro) => {
                int.id = indent + 1;
              });
            });
            // console.log(this.tableData);
            //关键节点城市经纬度
            lstOne.forEach((item, index, arr) => {
              item.trackList.forEach((ins) => {
                //经度
                let gjLng = ins.longtitude;
                //维度
                let gjLat = ins.latitude;
                //添加关键节点城市经纬度
                lngArr.push(gjLng);
                latArr.push(gjLat);
              });
              //坐标点经纬度
              zbdLng.push(item.port.longtitude);
              zbdLat.push(item.port.latitude);
            });
            //首发城市经纬度
            let startLngarr = lstOne[lstOne.length - 1];
            //首发城市经度
            let startLng =
              startLngarr.trackList[startLngarr.trackList.length - 1]
                .longtitude;
            //首发城市纬度
            let startLat =
              startLngarr.trackList[startLngarr.trackList.length - 1].latitude;
            //添加首发城市经纬度
            lngArr.push(startLng);
            latArr.push(startLat);
            //坐标点添加首发城市经纬度
            zbdLng.push(startLng);
            zbdLat.push(startLat);
            //合成对象数组并赋值给数据集合
            this.polylinePath = lngArr.map((item, index) => {
              return {
                lng: item,
                lat: latArr[index],
              };
            });
            //合成坐标点对象数组并赋值给数据集合
            this.zbdPath = zbdLng.map((ints, indet) => {
              return {
                lng: ints,
                lat: zbdLat[indet],
              };
            });
          } else {
            this.closeLoading(this.openLoading());
            this.$message({
              message: "暂无信息",
              type: "warning",
              offset: 200,
            });
            this.gloalData = []
          }
        })
        .catch((err) => {
          this.closeLoading(this.openLoading());
          // this.$message({
          //   message: "暂无信息",
          //   type: "warning",
          //   offset: 200,
          // });
          // console.log(err);
        });
    },

    async getAirData() {
      let { data: res } = await this.$axios.post("/Airtrans/index", {
        serchText: this.serchText,
        serchType: this.serchType,
      });
      if (res.code == 1) {
        this.airtransNo = res.data.airtransinfo.airtransno;
        this.origin = res.data.airtransinfo.origin;
        this.destination = res.data.airtransinfo.destination;
        this.latest_trace = res.data.airtransinfo.latest_trace;
        this.latTime = res.data.airtransinfo.latdate

        // 航班信息
        this.airflights = res.data.airflights;
        // 当前进程
        this.airprocess = res.data.airprocess;
        // 历史记录
        this.airhistory = res.data.airhistory;
      } 
    },

    //左侧信息伸缩控制
    flexBoxs(index) {
      this.isTrue = index;
    },
    //左侧表格首行改色
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return `color:#f00;`;
      } else {
        return "";
      }
    },
    //右侧地图Map
    handler({ BMap, map }) {
      // console.log(BMap, map);
      //中心点经度
      this.center.lng = 69.18;
      //中心点维度
      this.center.lat = 41.2;
      this.zoom = 1;
    },
    infoWindowClose(e) {
      this.infoWindow.show = false;
    },
    infoWindowOpen(e) {
      this.infoWindow.show = true;
    },
    //延时loading
    openLoading() {
      const loading = this.$loading({
        lock: true,
        text: "数据加载中,请稍后......",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.2)",
      });
      return loading;
    },
    closeLoading(loading) {
      loading.close();
    },
    // //地图切换
    // baiduMap() {
    //   this.baidusty = { display: "block" };
    //   this.bingsty = { display: "none" };
    //   this.acTrue = !this.acTrue;
    // },
    // bingMap() {
    //   this.baidusty = { display: "none" };
    //   this.bingsty = { display: "block" };
    //   this.acTrue = !this.acTrue;
    // },
  },
  components: {
    Footer,
  },
};
</script>
<style>
.el-table td,
.el-table th {
  text-align: center !important;
}

.history-panel {
  width: 1180px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  margin-top: 5px;
  padding: 8px 10px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 999;
}
.history-header {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}
.history-item {
  padding: 5px 0;
  font-size: 13px;
  cursor: pointer;
  color: #606266;
}
.history-item:hover {
  color: #409eff;
  background: #f5f7fa;
  padding-left: 5px;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}

.el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}

.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  color: #303133 !important;
}

.el-empty__description {
  margin-top: 0 !important;
}

.el-data-hublist {
  overflow: hidden;
  height: 360px;
}
</style>
<style scoped>
@import "./base/main.css";
</style>



// WEBPACK FOOTER //
// src/components/main/main.vue